(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('bcmResponsibilityFullController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', 'govNotificationDelay', 'historyCtxtService', 'bcmResponsibilityService', 'biaResponsibilityService'];

    function Controller($scope, $timeout, $state, govNotificationDelay, historyCtxtService, bcmResponsibilityService, biaResponsibilityService) {

        $scope.ctrlCtxt = {};

        // Page is dirty
        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = true;
        };
        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = false;

        };
        // Is Save Changes Disabled?
        $scope.isSaveChangesDisabled = function (form) {
            if (_.isUndefined(form)) return;
            return form.$invalid;
        };

        // Save Changes
        $scope.saveChanges = function () {

            if (_.isUndefined($scope.boxModel.BCMResponsibilityID)) {
                $scope.createBCMResponsibility();
                return;
            } 

            $scope.updateBCMResponsibility();
        };

        // Create BCM Responsibility
        $scope.createBCMResponsibility = function () {

            if ($scope.isSaveChangesDisabled($scope.form)) {
                $scope.ctrlCtxt.showSubmitError = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                    $scope.ctrlCtxt.showSubmitError = false;
                }, govNotificationDelay);

                return;
            }

            $scope.ctrlCtxt.showSubmitError = false;
            $scope.ctrlCtxt.isFormInvalidMsgShow = false;

            return bcmResponsibilityService
                .createBCMResponsibility($scope.boxContext.CreateForBIAProfile.BIAProfileID, $scope.boxModel)
                .then(function (createdBCMResp) {
                    if (_.isUndefined($scope.boxContext.CreateForBIAProfile)) return;

                    createdBCMResp.BIAProfileID = $scope.boxContext.CreateForBIAProfile.BIAProfileID;

                    return biaResponsibilityService
                        .createBIAResponsibility(createdBCMResp.BIAProfileID, createdBCMResp)
                        .then(function (createdBIAResp) {
                            $state.go('biaProfile.edit.biaBuOwner.biaResponsibility', {
                                BIAResponsibilityID: createdBIAResp.BIAResponsibilityID
                            });
                        });
                });
        };

        // Update BCM Responsibility
        $scope.updateBCMResponsibility = function () {

            if ($scope.isSaveChangesDisabled($scope.form)) {
                $scope.ctrlCtxt.showSubmitError = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                    $scope.ctrlCtxt.showSubmitError = false;
                }, govNotificationDelay);

                return;
            }

            $scope.ctrlCtxt.showSubmitError = false;
            $scope.ctrlCtxt.isFormInvalidMsgShow = false;

            return bcmResponsibilityService
                .updateBCMResponsibility($scope.boxModel.BCMResponsibilityID, $scope.boxModel)
                .then(function (updatedBCMResp) {
                    $scope.boxModel = updatedBCMResp;
                    $state.go('^', {}, {reload: true});
                });
        };

        // Reset
        $scope.reset = function () {
            $state.reload();
        };

        // Close Modal
        $scope.closeModal = function () {
            $scope.boxContext.OnModalClose();
        };
    }

})();